<template>
	<el-container class="home-container">
		<el-aside v-if="isShowSideBar" :width="isCollapse ? '64px' : '230px'" class="sidebar-container">
			<div class="logo">
				<h2 v-if="!isCollapse">{{ t('siteTitle') }}</h2>
				<h2 v-else>AIM</h2>
			</div>
			<el-menu
				:default-active="activeIndex"
				background-color="#304156"
				text-color="#fff"
				active-text-color="#409EFF"
				:collapse="isCollapse"
				:collapse-transition="false"
				router
			>
			<el-menu-item 
				v-for="route in menuRoutes" 
				:key="route.path"
				:index="route.path"
			>
				<i :class="route.meta.icon"></i>
				<template v-slot:title>
					<span>{{ t(route.meta.titleKey) }}</span>
				</template>
			</el-menu-item>
			</el-menu>
		</el-aside>

		<el-container>
			<el-header>
				<div class="header-left">
					<i
						v-if="isShowSideBar"
						:class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
						class="toggle-button"
						@click="toggleSideBar"
					></i>
					<el-breadcrumb separator="/" v-if="isShowSideBar">
						<template v-if="$route.meta.breadcrumb">
							<el-breadcrumb-item
								v-for="(item, index) in $route.meta.breadcrumb"
								:key="index"
								:to="item.path ? { path: item.path } : null"
							>
								{{ item.nameKey ? t(item.nameKey) : item.name }}
							</el-breadcrumb-item>
						</template>
						<template v-else>
							<el-breadcrumb-item :to="{ path: '/' }">{{ t('home') }}</el-breadcrumb-item>
							<el-breadcrumb-item v-if="$route.meta.titleKey">{{
								t($route.meta.titleKey)
							}}</el-breadcrumb-item>
						</template>
					</el-breadcrumb>
				</div>
				<div class="header-right">
					<el-button type="text" class="feedback-button" @click="showFeedbackDialog">{{ t('feedback.button') }}</el-button>
					<el-button type="text" class="switch-version-button" @click="switchToNewVersion">切换到新版</el-button>
					<el-tooltip
						:content="t('fullscreen')"
						effect="dark"
						placement="bottom"
						v-if="!isDingTalk"
					>
						<i class="el-icon-full-screen screen-button" @click="toggleFullScreen"></i>
					</el-tooltip>
					<!-- <el-tooltip content="消息" effect="dark" placement="bottom">
						<el-badge :value="3" class="message-badge">
							<i class="el-icon-bell message-button"></i>
						</el-badge>
					</el-tooltip> -->
					<!-- <span class="el-dropdown-link">
						<el-avatar :size="30" :src="userInfo.avatar"></el-avatar>
						<span class="username">{{ userInfo.name }}</span>
					</span> -->
					<!-- <el-dropdown
						@command="handleLanguageChange"
						trigger="click"
						class="language-dropdown"
					>
						<span class="language-selector">
							<i class="el-icon-globe"></i>
							<span class="language-text">{{ getLanguageIcon() }}</span>
						</span>
						<template v-slot:dropdown>
							<el-dropdown-menu>
								<el-dropdown-item v-for="lang in languages" :key="lang.code" :command="lang.code">
									<span>{{ lang.icon }} {{ lang.name }}</span>
								</el-dropdown-item>
							</el-dropdown-menu>
						</template>
					</el-dropdown> -->
					<!-- <LanguageSwitch :showArrow="true" /> -->
					<LanguageSwitch :showArrow="true" class="language-switch-con" :accessToken="token" :syncToIframes="true" />
					<el-dropdown @command="handleCommand" v-if="!isInIframe && !isDingTalk&&isShowSideBar">
						<span class="el-dropdown-link">
							<el-avatar :size="30" :src="userInfo.avatar" :style="getAvatarStyle">
							{{ !userInfo.avatar ? getDefaultAvatarText : '' }}
							</el-avatar>
							<span class="username">{{ userInfo.name }}</span>
							<i class="el-icon-arrow-down el-icon--right"></i>
						</span>
						<template v-slot:dropdown>
							<el-dropdown-menu>
							<el-dropdown-item command="logout">{{ t('logout') }}</el-dropdown-item>
							</el-dropdown-menu>
						</template>
						</el-dropdown>

						<!-- iframe环境，只显示头像和用户名 -->
						<span class="el-dropdown-link" v-else>
						<el-avatar :size="30" :src="userInfo.avatar" :style="getAvatarStyle">
							{{ !userInfo.avatar ? getDefaultAvatarText : '' }}
						</el-avatar>
						<span class="username">{{ userInfo.name }}</span>
						</span>
				</div>
			</el-header>

			<el-main>
				<div class="main-container">
					<transition name="fade-transform" mode="out-in">
						<router-view />
					</transition>
				</div>
			</el-main>
		</el-container>
		<el-dialog
			:title="t('feedback.title')"
			:visible.sync="feedbackDialogVisible"
			width="500px"
			custom-class="feedback-dialog"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
		>
			<div>
				<el-input
					type="textarea"
					v-model="feedbackContent"
					:rows="6"
					:placeholder="t('feedback.placeholder')"
				></el-input>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="feedbackDialogVisible = false" :disabled="submitLoading">{{ t('feedback.cancel') }}</el-button>
				<el-button type="primary" @click="submitFeedback" :loading="submitLoading">{{ t('feedback.submit') }}</el-button>
			</span>
		</el-dialog>	
	</el-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { redirectToLogin } from '@/utils/auth';
import { getCurrentLang, t, switchLanguage, getSupportedLanguages } from '@/utils/i18nHelper';
import axios from 'axios';
import { getDevice } from '@/utils/util';
// import LanguageSwitch from '@/components/LanguageSwitch/index.vue';
import { LanguageSwitch } from 'dc-translation-manager';


export default {
	name: 'HomePage',
	components: {
		LanguageSwitch
	},
	data() {
		return {
			isCollapse: false,
			isShowSideBar: true,
			activeIndex: '/',
			currentLang: getCurrentLang(),
			languages: getSupportedLanguages(),
			feedbackDialogVisible: false,
			feedbackContent: '',
			submitLoading: false,
			isInIframe: false,
			isDingTalk: false,
		};
	},
	computed: {
		...mapGetters(['userInfo', 'token']),
		getDefaultAvatarText() {
			return this.userInfo.name ? this.userInfo.name.slice(-1) : '';
		},
		getAvatarStyle() {
			return !this.userInfo.avatar
				? {
						backgroundColor: '#409EFF',
						color: '#ffffff',
						fontSize: '16px',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
				  }
				: {};
		},
		menuRoutes() {
			const routes = this.$router.options.routes
				.find(route => route.path === '/')
				.children;
			
			return routes
				.filter(route => route.meta && route.meta.showInMenu)
				.sort((a, b) => (a.meta.order || 0) - (b.meta.order || 0));
		},
	},
	created() {
		let navMenu=this.$route.query.navMenu;
		this.isShowSideBar = !(navMenu=='0'||navMenu=='false'||navMenu==false);
		this.activeIndex = this.$route.path;
		this.isInIframe = window.self !== window.top;
		const Device = getDevice(); // 识别环境
		// 判断是否是钉钉环境
		if(Device.app === 'dingtalk'){
			this.isDingTalk = true;
		}
		console.log(this.userInfo);
	},
	watch: {
		$route: {
			handler(route) {
				this.activeIndex = route.path;
			},
			immediate: true,
		},
	},
	methods: {
		t(key, params) {
			return t(key, params);
		},

		getLanguageIcon() {
			const lang = this.languages.find(l => l.code === this.currentLang);
			return lang ? lang.icon : '🌐';
		},

		handleLanguageChange(lang) {
			this.currentLang = switchLanguage(lang);

			import('@/router').then(module => {
				if (module.updateRouteLanguage) {
					module.updateRouteLanguage();
				}
			});

			this.$forceUpdate();

			this.$root.$emit('languageChanged', this.currentLang);

			window.location.reload();
		},
		toggleSideBar() {
			this.isCollapse = !this.isCollapse;
		},
		toggleFullScreen() {
			if (!document.fullscreenElement) {
				document.documentElement.requestFullscreen();
			} else {
				if (document.exitFullscreen) {
					document.exitFullscreen();
				}
			}
		},
		switchToNewVersion() {
			const currentUrl = window.location.href;
			const newUrl = currentUrl.replace('/ai-report/', '/ai-report2/');
			window.location.href = newUrl;
		},
		handleCommand(command) {
			switch (command) {
				case 'logout':
					this.logout();
					break;
				case 'profile':
					this.$router.push('/profile');
					break;
				case 'settings':
					this.$router.push('/account-settings');
					break;
			}
		},
		logout() {
			this.$confirm(t('confirmLogout'), t('tip'), {
				confirmButtonText: t('confirm'),
				cancelButtonText: t('cancel'),
				type: 'warning',
			})
				.then(() => {
					this.$store.dispatch('user/logout');
					redirectToLogin();
				})
				.catch(() => {});
		},
		showFeedbackDialog() {
			this.feedbackDialogVisible = true;
			this.feedbackContent = '';
		},
		submitFeedback() {
			if (!this.feedbackContent.trim()) {
				this.$message({
					message: t('feedback.error'),
					type: 'warning'
				});
				return;
			}
			this.submitLoading = true;
			const params = {
				feedType: 'qbfkzs',
				content: this.feedbackContent,
				dingUserId: this.userInfo.dingUserId,
				name: this.userInfo.name,
				corpId: this.userInfo.corpId
			};
			
			const DINGTALK_WEBHOOK = 'https://xg-node.xgjktech.com.cn/api/feed/addFeedback';
			axios.post(DINGTALK_WEBHOOK, params, {
				headers: {
					'Content-Type': 'application/json'
				}
			}).then(response => {
				console.log(response);
				if (response.data.status == 200) {
					this.$message({
						message: t('feedback.success'),
						type: 'success'
					});
					this.feedbackDialogVisible = false;
				} else {
					this.$message({
						message: response.data.data.errmsg || t('feedback.error'),
						type: 'error'
					});
				}
			}).catch(error => {
				console.error('反馈提交失败：', error);
				this.$message({
					message: error.response?.data?.data?.errmsg || t('feedback.error'),
					type: 'error'
				});
			}).finally(() => {
				this.submitLoading = false;
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.home-container {
	height: 100vh;
	.feedback-button{
		color: #409EFF;
		font-size: 14px;
	}

	.switch-version-button {
		color: #409EFF;
		font-size: 14px;
	}

	.sidebar-container {
		background-color: #304156;
		color: white;
		transition: width 0.3s;
		overflow: hidden;
	}

	.logo {
		height: 60px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: white;
		background-color: #263445;
		overflow: hidden;
	}

	.el-header {
		height: 60px;
		line-height: 60px;
		background-color: #fff;
		color: #333;
		display: flex;
		justify-content: space-between;
		align-items: center;
		box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
		padding: 0 15px;
	}

	.header-left {
		display: flex;
		align-items: center;
	}

	.toggle-button {
		font-size: 20px;
		margin-right: 15px;
		cursor: pointer;
	}

	.screen-button,
	.message-button {
		font-size: 18px;
		cursor: pointer;
	}

	.header-right {
		display: flex;
		align-items: center;
		gap: 12px;
	}

	::v-deep .language-switch-con{
		.language-switch{
			.language-switch-img{
				width: 17px !important;
				height: 17px !important;
			}
		}
	}

	.message-badge {
		margin-right: 15px;
	}

	.el-dropdown-link {
		display: flex;
		align-items: center;
		cursor: pointer;
		height: 60px;
	}

	.username {
		margin: 0 10px;
		font-size: 14px;
	}

	.el-main {
		background-color: #f0f2f5;
		padding: 15px;
		overflow-y: auto;
	}

	.main-container {
		background-color: #fff;
		// padding: 20px;
		box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
		border-radius: 4px;
		min-height: calc(100vh - 100px);
	}

	.fade-transform-enter-active,
	.fade-transform-leave-active {
		transition: all 0.3s;
	}

	.fade-transform-enter {
		opacity: 0;
		transform: translateX(20px);
	}

	.fade-transform-leave-to {
		opacity: 0;
		transform: translateX(-20px);
	}

	.el-menu {
		border-right: none;
	}

	.el-menu--collapse {
		width: 64px;
	}

	.language-dropdown {
		cursor: pointer;
	}

	.language-selector {
		display: flex;
		align-items: center;
		color: #606266;
	}

	.language-selector i {
		font-size: 20px;
		margin-right: 5px;
	}

	.language-text {
		font-size: 16px;
	}

	.el-dropdown-menu {
		padding: 6px 0;
	}

	.el-dropdown-menu__item {
		padding: 6px 20px;
		line-height: 1.5;
		display: flex;
		align-items: center;
	}
	.el-dropdown-menu__item--divided:before {
		margin: 0;
	}
}
</style>
<style lang="scss">
.feedback-dialog {
	border-radius: 10px;
}
</style>
